import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import isAccessTokenValid from '@app/helpers/isAccessTokenValid'
import isUserLoggedIn from '@app/helpers/isUserLoggedIn'
import { patchGeofence, postGeofence } from '@app/actions/geofences/geofences'
import * as syncNotifications from '@app/actions/notifications/notificationsChannel'
import CreateGeofenceScreen from '@app/components/Geofences/CreateGeofenceScreen/CreateGeofenceScreen'
import {
  withNotifications, withAccessDenied, withProgressAndErrorMessage, withForbiddenAccess, withRouter,
} from '@app/hocs'

let enhance = CreateGeofenceScreen

const mapStateToProps = (state) => {
  const { isMobile, isTablet } = state.mobileDetector
  const { geofences: { fetchedGeofences } } = store.getState()
  const forbiddenRoles = ['guest']
  const currentRole = state.users.currentUser.user.role
  return {
    isMobile,
    isTablet,
    fetchedGeofences,
    forbiddenRoles,
    currentRole,
    accessToken: state.secrets.accessToken && state.secrets.accessToken.token,
    inProgress: state.apiRequest.inProgress,
    errorMessage: state.apiRequest.errorMessage,
    accessDenied: !isAccessTokenValid(state.secrets.accessToken),
    userLoggedIn: (isUserLoggedIn(state.users.currentUser.user.preferredName)),
  }
}

const mapDispatchToProps = (dispatch) => bindActionCreators({
  notifications: syncNotifications.sync,
  postGeofence,
  patchGeofence,
}, dispatch)

enhance = withRouter(enhance)
enhance = withForbiddenAccess(enhance)
enhance = withNotifications(enhance)
enhance = withProgressAndErrorMessage(enhance)
enhance = withAccessDenied(enhance)
enhance = connect(mapStateToProps, mapDispatchToProps)(enhance)

const CreateGeofenceScreenEnhanced = enhance

export default CreateGeofenceScreenEnhanced
